import { Grid, withStyles } from "@material-ui/core";
import React from "react";
import CustomTextField from "components/UpdateUi/CustomeTextField";
import SchemeChargeDetails from "./SchemeChargeDetails";
const style = () => ({
  button2: {
    marginRight: "10px",
  },
  buttonDelContainer: {
    marginTop: "10px",
  },
});
const SchemeCharge = ({ classes, groupDetails, lastIndex, enabledMinMAxPercentageFieldsCharges }) => {

  return (
    <>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        className={`${classes.inputFieldContainer} ${classes.chargeContainer}`}
      >
        <h2 className={classes.header}>Scheme Charges</h2>
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        {Array.apply(null, { length: lastIndex + 1 }).map((e, i) => (
          <Grid container className={classes.inputFieldContainer} key={i}>
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomTextField
                label="Charges"
                required
                value={groupDetails?.[i]?.name}
                id={`scheme_charges${i}`}
                disabled={true}
                index={i}
                type="newSchemeCharge"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomTextField
                label="ChargeNature"
                value={groupDetails?.[i]?.chargeNature}
                id={`scheme_chargeNature${i}`}
                disabled={true}
                index={i}
                type="newSchemeCharge"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomTextField
                label="ChargeType"
                value={groupDetails?.[i]?.chargeType}
                id={`scheme_chargeType${i}`}
                disabled
                index={i}
                type="newSchemeCharge"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomTextField
                label="Value"
                required
                value={groupDetails?.[i]?.value}
                id={`scheme_value${i}`}
                disabled={true}
                index={i}
                type="newSchemeCharge"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomTextField
                label="MinAmount"
                required
                disabled={true}
                id={`scheme_minAmount${i}`}
                value={
                  groupDetails?.[i]?.chargeNature === "FLAT"
                    ? groupDetails?.[i]?.value
                    : groupDetails?.[i]?.minAmt
                }
                index={i}
                type="newSchemeCharge"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomTextField
                label="MaxAmount"
                required
                disabled={true}
                id={`scheme_maxAmount${i}`}
                value={
                  groupDetails?.[i]?.chargeNature === "FLAT"
                    ? groupDetails?.[i]?.value
                    : groupDetails?.[i]?.maxAmt
                }
                index={i}
                type="newSchemeCharge"
              />
            </Grid>
            {groupDetails?.[i]?.chargeNature === "PERCENTAGE" && groupDetails?.[i]?.chargeType === "PROCESSING_FEE" && enabledMinMAxPercentageFieldsCharges &&
            <>
              <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
                <CustomTextField
                  label="Min Percentage"
                  required
                  disabled={true}
                  id={`scheme_minamount${i}`}
                  value={groupDetails?.[i]?.data?.PROCESSINGFEE_PERCENTAGE?.MIN_PERCENTAGE}
                  index={i}
                  type="percentageNumber"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
                <CustomTextField
                  label="Max Percentage"
                  required
                  disabled={true}
                  id={`scheme_maxamount${i}`}
                  value={groupDetails?.[i]?.data?.PROCESSINGFEE_PERCENTAGE?.MAX_PERCENTAGE}
                  index={i}
                  type="percentageNumber"
                />
              </Grid>
            </>
            }
            {(groupDetails?.[i]?.chargeType === "CUSTODY" ||
              groupDetails?.[i]?.chargeType === "PREPAYMENT") && (
              <>
                <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
                  <CustomTextField
                    label="Criteria Value"
                    required
                    value={
                      groupDetails[i].chargeType === "CUSTODY"
                        ? "LTV"
                        : "LOAN AMOUNT"
                    }
                    disabled={true}
                    index={i}
                    id={`scheme_criteria_value${i}`}
                    type="newSchemeCharge"
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
                  <CustomTextField
                    label="Criteria Amount"
                    required
                    value={groupDetails?.[i]?.criteriaAmt}
                    disabled={true}
                    id={`scheme_criteria_amount${i}`}
                    index={i}
                    type="newSchemeCharge"
                  />
                </Grid>
              </>
            )}
            <Grid
              xs={12}
              sm={6}
              md={4}
              className={classes.fieldContaienr}
              style={{ display: "flex", flexWrap: "wrap" ,textAlign:"left"}}
            >
              <Grid item xs={12} sm={6} md={6}>
                <span style={{ fontWeight: "bold" }}>
                  {" "}
                  <input
                    id="selectAll"
                    type="checkbox"
                    checked={groupDetails?.[i]?.disbursalTime}
                    disabled={true}
                    className={classes.checkboxInput}
                  />{" "}
                  Disbursal Time
                </span>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <span style={{ fontWeight: "bold" }}>
                  {" "}
                  <input
                    id="selectAll"
                    type="checkbox"
                    checked={groupDetails?.[i]?.gstApplicable}
                    disabled={true}
                    className={classes.checkboxInput}
                  />{" "}
                  GST Applicable
                </span>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <span style={{ fontWeight: "bold" }}>
                  {" "}
                  <input
                    id="selectAll"
                    type="checkbox"
                    checked={groupDetails?.[i]?.excludingGst}
                    disabled={true}
                    className={classes.checkboxInput}
                  />{" "}
                  Exclude GST
                </span>
              </Grid>
            </Grid>
            <SchemeChargeDetails chargeDetails={groupDetails[i]?.chargeDetails} classes={classes}   groupindex ={i} />
          </Grid>
        ))}
      </Grid>
    </>
  );
};
export default withStyles(style)(SchemeCharge);